import { keyframes, Stack, Typography, useTheme } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { RainbowAnimatedIcon } from './RainbowAnimatedIcon';

const rainbowFlow = keyframes`
    0% { background-position: 0% 0%; }
    100% { background-position: 1000% 0%; }
`;

export const RainbowAnimatedText: React.FC<PropsWithChildren> = ({
  children
}) => {
  const { palette } = useTheme();
  return (
    <Stack direction="row" alignItems="center" gap="2px">
      <RainbowAnimatedIcon />
      <Typography
        fontWeight="600"
        sx={{
          background: palette.aiGradient,
          backgroundSize: '600% 100%',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          animation: `${rainbowFlow} 20s linear infinite`
        }}
      >
        {children}
      </Typography>
    </Stack>
  );
};
